import React from "react";
import { useForm, Controller } from "react-hook-form";
import axios from "axios";
import { useSelector } from "react-redux";
import { useState, useEffect } from "react";
import {
  CheckCircle,
  Circle,
  AlertTriangle,
  X,
  Loader,
  AlertCircle,
} from "lucide-react";
import { testConnectivity } from "../../../services/endpoint/EndpointFormFunction";
const AddEndpointForm = ({ close, refresh, setRefresh }) => {
  const [showSuccess, setShowSuccess] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [step, setStep] = React.useState(1);
  const [apiType, setApiType] = React.useState([]);
  const [oemOptions, setOemOptions] = React.useState([]);
  const [productOptions, setProductOptions] = React.useState([]);
  const [environmentOptions, setEnvironmentOptions] = React.useState([]);
  const [inputsChangedSinceTest, setInputsChangedSinceTest] = useState(false);
  const [connectivityError, setConnectivityError] = React.useState(null);
  const [isConnectivityTesting, setIsConnectivityTesting] =
    React.useState(false);
  const [showError, setShowError] = React.useState(false);
  const [error, setError] = useState(null);
  const [isConnectivitySuccess, setIsConnectivitySuccess] = useState(false);
  const accessToken = useSelector((state) => state.accessToken.value);
  const apiUrl = process.env.REACT_APP_API_URL;

  const {
    register,
    handleSubmit,
    watch,
    trigger,
    control,
    setValue,
    getValues,
    formState: { errors },
  } = useForm({
    defaultValues: {
      ProductName: "",
      OemName: "",
      Environment: "",
      selectedAPIs: {},
      apiDetails: {},
    },
  });

  const watchedApiDetails = watch([
    "apiDetails.WEB",
    "apiDetails.HEALTH",
    "apiDetails.AUTH",
    "apiDetails.authApiUsername",
    "apiDetails.authApiPassword",
  ]);

  React.useEffect(() => {
    const fetchData = async () => {
      try {
        const query = `
            query GetDetails($id: String!) {
              getDetails(id: $id) {
                id
                oem
                region
                environment
                product
              }
            }
          `;

        const response = await axios.post(
          apiUrl,
          { query, variables: { id: "1" } },
          { headers: { Authorization: accessToken } }
        );
        const data = response.data.data.getDetails;
        setOemOptions(Object.keys(JSON.parse(data.oem)));
        setProductOptions(Object.keys(JSON.parse(data.product)));
        setEnvironmentOptions(Object.keys(JSON.parse(data.environment)));
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    const getApiTypes = async () => {
      try {
        const query = `
            query MyQuery($id: String!) {
              getApiType(id: $id) {
                ApiType
              }
            }
          `;
        const response = await axios.post(
          apiUrl,
          { query, variables: { id: "2" } },
          { headers: { Authorization: accessToken } }
        );
        const data = response.data.data.getApiType;
        setApiType(
          Object.entries(JSON.parse(data.ApiType)).map(
            ([name, description]) => ({
              name,
              description,
            })
          )
        );
      } catch (error) {
        console.error("Error fetching API types:", error);
      }
    };
    fetchData();
    getApiTypes();
  }, [accessToken, apiUrl]);

  useEffect(() => {
    if (step === 3 && isConnectivitySuccess) {
      setInputsChangedSinceTest(true);
      setIsConnectivitySuccess(false);
      setConnectivityError(null);
    }
  }, [...watchedApiDetails]);

  const steps = [
    { id: 1, title: "Product & OEM" },
    { id: 2, title: "Environment & API Types" },
    { id: 3, title: "API Details" },
  ];

  const includeApiDetails = (selectedAPIs, data) => ({
    authApiUrl: selectedAPIs.AUTH ? data.apiDetails.AUTH : null,
    authApiUsername: selectedAPIs.AUTH ? data.apiDetails.authApiUsername : null,
    authApiPassword: selectedAPIs.AUTH ? data.apiDetails.authApiPassword : null,
    webApiUrl: selectedAPIs.WEB ? data.apiDetails.WEB : null,
    healthApiUrl: selectedAPIs.HEALTH ? data.apiDetails.HEALTH : null,
  });

  const handleNextStep = async () => {
    let isValid = false;
    if (step === 1) {
      isValid = await trigger(["ProductName", "OemName"]);
    } else if (step === 2) {
      isValid = await trigger(["Environment"]);
      const hasSelectedApi = Object.values(watch("selectedAPIs")).some(
        (value) => value
      );
      if (!hasSelectedApi) {
        setShowError(true);
        return;
      }
      setShowError(false);
    }

    if (isValid) {
      setStep(step + 1);
    }
  };
  const ErrorHandling = async () => {
    setIsConnectivityTesting(true);
    setConnectivityError(null);
    setInputsChangedSinceTest(false);
    const { apiDetails, selectedAPIs } = getValues();
    let allTestsPassed = true;
    let errorMessages = [];
    try {
      const hasSelectedApi = Object.values(selectedAPIs).some((value) => value);
      if (!hasSelectedApi) {
        setConnectivityError(
          "Please select at least one API type to test connectivity"
        );
        setIsConnectivitySuccess(false);
        return;
      }
      if (selectedAPIs.WEB && (apiDetails.WEB === "" || !apiDetails.WEB)) {
        errorMessages.push("Web API URL is required");
        allTestsPassed = false;
      }
      if (selectedAPIs.AUTH && (apiDetails.AUTH === "" || !apiDetails.AUTH)) {
        errorMessages.push("Auth API URL is required");
        allTestsPassed = false;
      }
      if (
        selectedAPIs.HEALTH &&
        (apiDetails.HEALTH === "" || !apiDetails.HEALTH)
      ) {
        errorMessages.push("Health API URL is required");
        allTestsPassed = false;
      }

      if (allTestsPassed) {
        // if (selectedAPIs.WEB && apiDetails.WEB) {
        //   const webResult = await testConnectivity(apiDetails.WEB);
        //   if (webResult !== "success") {
        //     errorMessages.push("Web API");
        //     allTestsPassed = false;
        //   }
        // }

        // if (selectedAPIs.HEALTH && apiDetails.HEALTH) {
        //   const healthResult = await testConnectivity(apiDetails.HEALTH);
        //   if (healthResult !== "success") {
        //     errorMessages.push("Health API");
        //     allTestsPassed = false;
        //   }
        // }

        if (selectedAPIs.AUTH && apiDetails.AUTH) {
          const authResult = await testConnectivity(
            apiDetails.AUTH,
            apiDetails.authApiUsername,
            apiDetails.authApiPassword
          );
          if (authResult !== "success") {
            errorMessages.push("Auth API");
            allTestsPassed = false;
          }
        }
      }

      if (!allTestsPassed) {
        const errorMessage = errorMessages.map((msg) => `- ${msg}`).join("\n");
        setIsConnectivitySuccess(false);
        setConnectivityError(
          `Failed to connect to the following APIs:\n${errorMessage}`
        );
      } else {
        setConnectivityError("✓ All connectivity tests passed successfully");
        setIsConnectivitySuccess(true);
      }
    } catch (error) {
      setConnectivityError("An error occurred during connectivity testing");
    } finally {
      setIsConnectivityTesting(false);
    }
  };
  const onSubmit = async (data) => {
    setIsSubmitting(true);
    const { selectedAPIs } = data;
    const mutationString = `
      mutation MyMutation(
        $ProductName: String!,
        $OemName: String!,
        $Environment: String!,
        $ApiType: String!,
        $authApiUrl: String,
        $authApiUsername: String,
        $authApiPassword: String,
        $healthApiUrl: String,
        $webApiUrl: String
      ) {
        addEndpointDetails(input: {
          ProductName: $ProductName,
          OemName: $OemName,
          Environment: $Environment,
          ApiType: $ApiType,
          authApiUrl: $authApiUrl,
          authApiUsername: $authApiUsername,
          authApiPassword: $authApiPassword,
          healthApiUrl: $healthApiUrl,
          webApiUrl: $webApiUrl
        })
      }
    `;
    try {
      const result = await axios.post(
        apiUrl,
        {
          query: mutationString,
          variables: {
            ...data,
            ApiType: "All",
            ...includeApiDetails(selectedAPIs, data),
          },
        },
        { headers: { Authorization: accessToken } }
      );

      if (
        result.data.errors &&
        result.data.errors[0].errorType == "Unauthorized"
      )
        setError("Add endpoint access is not granted to your account.");

      setShowSuccess(true);
      setTimeout(() => {
        close();
      }, 2000);
    } catch (error) {
      console.log(error);
      setConnectivityError("Failed to create endpoint");
    } finally {
      setIsSubmitting(false);
      setRefresh(!refresh);
    }
  };

  return (
    <div className="flex h-full bg-gray-50">
      {!showSuccess ? (
        <>
          <div className="w-72 bg-white p-8 border-r border-gray-200 shadow-sm">
            <h2 className="text-xl font-bold text-[#003366] mb-8">
              Create Endpoint
            </h2>
            <div className="space-y-6">
              {steps.map((s) => (
                <div
                  key={s.id}
                  className={`flex items-center space-x-3 transition-colors duration-200
                ${step === s.id ? "text-[#003366]" : "text-gray-500"}`}
                >
                  {step > s.id ? (
                    <CheckCircle className="w-6 h-6 text-green-600" />
                  ) : step === s.id ? (
                    <div className="w-6 h-6 rounded-full bg-[#003366] flex items-center justify-center text-white text-sm">
                      {s.id}
                    </div>
                  ) : (
                    <Circle className="w-6 h-6 text-gray-400" />
                  )}
                  <span
                    className={`font-medium ${step === s.id ? "text-[#003366]" : ""}`}
                  >
                    {s.title}
                  </span>
                </div>
              ))}
            </div>
          </div>
          <div className="flex-1 p-8 overflow-y-auto">
            <form
              onSubmit={handleSubmit(onSubmit)}
              className="max-w-3xl mx-auto space-y-8"
            >
              {step === 3 && connectivityError && (
                <div
                  className={`flex items-center p-4 rounded-lg border ${
                    connectivityError.includes("success")
                      ? "bg-green-50 border-green-200 text-green-700"
                      : "bg-red-50 border-red-200 text-red-700"
                  }`}
                >
                  {connectivityError.includes("success") ? (
                    <CheckCircle className="w-5 h-5 mr-3" />
                  ) : (
                    <AlertTriangle className="w-5 h-5 mr-3" />
                  )}
                  <span className="flex-1 whitespace-pre-line">
                    {connectivityError}
                  </span>
                  <button
                    type="button"
                    onClick={() => setConnectivityError(null)}
                    className="ml-3 hover:opacity-70"
                  >
                    <X className="w-5 h-5" />
                  </button>
                </div>
              )}

              {step === 1 && (
                <div className="space-y-8">
                  <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
                    <h3 className="text-lg font-medium text-[#003366] mb-6">
                      Select Product
                    </h3>
                    <div className="space-y-3">
                      {productOptions.map((product) => (
                        <label
                          key={product}
                          className="flex items-center p-3 rounded-lg hover:bg-gray-50 cursor-pointer transition-colors"
                        >
                          <input
                            type="radio"
                            value={product}
                            {...register("ProductName", {
                              required: "Please select a product",
                            })}
                            className="w-4 h-4 text-[#003366] border-gray-300 focus:ring-[#003366]"
                          />
                          <span className="ml-3 text-gray-700">{product}</span>
                        </label>
                      ))}
                    </div>
                    {errors.ProductName && (
                      <p className="mt-2 text-sm text-red-600">
                        {errors.ProductName.message}
                      </p>
                    )}
                  </div>

                  <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
                    <h3 className="text-lg font-medium text-[#003366] mb-6">
                      Select OEM
                    </h3>
                    <select
                      {...register("OemName", {
                        required: "Please select an OEM",
                      })}
                      className="w-full p-3 border border-gray-300 rounded-lg focus:ring-[#003366] focus:border-[#003366]"
                    >
                      <option value="">Select an OEM</option>
                      {oemOptions.map((oem) => (
                        <option key={oem} value={oem}>
                          {oem}
                        </option>
                      ))}
                    </select>
                    {errors.OemName && (
                      <p className="mt-2 text-sm text-red-600">
                        {errors.OemName.message}
                      </p>
                    )}
                  </div>
                  <div className="flex justify-end mt-8">
                    <button
                      type="button"
                      onClick={handleNextStep}
                      className="px-4 py-2 bg-[#003366] text-white rounded-md hover:bg-[#002244] transition-colors"
                    >
                      Next
                    </button>
                  </div>
                </div>
              )}

              {step === 2 && (
                <div className="space-y-8">
                  <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
                    <h3 className="text-lg font-medium text-[#003366] mb-6">
                      Select Environment
                    </h3>
                    <select
                      {...register("Environment", {
                        required: "Please select an environment",
                      })}
                      className="w-full p-3 border border-gray-300 rounded-lg focus:ring-[#003366] focus:border-[#003366]"
                    >
                      <option value="">Select an Environment</option>
                      {environmentOptions.map((env) => (
                        <option key={env} value={env}>
                          {env}
                        </option>
                      ))}
                    </select>
                    {errors.Environment && (
                      <p className="mt-2 text-sm text-red-600">
                        {errors.Environment.message}
                      </p>
                    )}
                  </div>

                  <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
                    <h3 className="text-lg font-medium text-[#003366] mb-6">
                      Select API Types
                    </h3>
                    <div className="grid gap-4 grid-cols-1 md:grid-cols-2">
                      {apiType.map((api) => (
                        <label
                          key={api.name}
                          className="flex items-center p-4 border rounded-lg hover:bg-gray-50 cursor-pointer transition-colors"
                        >
                          <input
                            type="checkbox"
                            {...register(`selectedAPIs.${api.name}`)}
                            className="w-4 h-4 text-[#003366] border-gray-300 rounded focus:ring-[#003366]"
                          />
                          <span className="ml-3 text-gray-700">
                            {api.description}
                          </span>
                        </label>
                      ))}
                    </div>
                    {showError && (
                      <p className="mt-2 text-sm text-red-600">
                        Please select at least one API type
                      </p>
                    )}
                  </div>
                  <div className="flex justify-between mt-8">
                    <button
                      type="button"
                      onClick={() => setStep(step - 1)}
                      className="px-4 py-2 border border-gray-300 text-gray-600 rounded-md hover:bg-gray-50 transition-colors"
                    >
                      Back
                    </button>
                    <button
                      type="button"
                      onClick={handleNextStep}
                      className="px-4 py-2 bg-[#003366] text-white rounded-md hover:bg-[#002244] transition-colors"
                    >
                      Next
                    </button>
                  </div>
                </div>
              )}

              {step === 3 && (
                <div className="space-y-6 bg-white rounded-lg shadow-sm border border-gray-200 p-6">
                  {watch("selectedAPIs.WEB") && (
                    <div className="space-y-4">
                      <div className="flex items-center justify-between">
                        <h3 className="text-lg font-medium text-[#003366]">
                          Web API Details
                        </h3>
                        <button
                          type="button"
                          onClick={() => {
                            setValue("selectedAPIs.WEB", false);
                            setValue("apiDetails.WEB", "");
                          }}
                          className="text-gray-500 hover:text-gray-700"
                        >
                          <X className="w-5 h-5" />
                        </button>
                      </div>
                      <Controller
                        name="apiDetails.WEB"
                        control={control}
                        rules={{
                          required: "Web URL is required",
                          pattern: {
                            value: /^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/i,
                            message: "Please enter a valid URL",
                          },
                        }}
                        render={({ field }) => (
                          <div>
                            <input
                              {...field}
                              type="text"
                              placeholder="Enter Web URL"
                              className="w-full p-3 border border-gray-300 rounded-lg focus:ring-[#003366] focus:border-[#003366]"
                            />
                            {errors.apiDetails?.WEB && (
                              <p className="mt-2 text-sm text-red-600">
                                {errors.apiDetails.WEB.message}
                              </p>
                            )}
                          </div>
                        )}
                      />
                    </div>
                  )}

                  {watch("selectedAPIs.HEALTH") && (
                    <div className="space-y-4">
                      <div className="flex items-center justify-between">
                        <h3 className="text-lg font-medium text-[#003366]">
                          Health API Details
                        </h3>
                        <button
                          type="button"
                          onClick={() => {
                            setValue("selectedAPIs.HEALTH", false);
                            setValue("apiDetails.HEALTH", "");
                          }}
                          className="text-gray-500 hover:text-gray-700"
                        >
                          <X className="w-5 h-5" />
                        </button>
                      </div>
                      <Controller
                        name="apiDetails.HEALTH"
                        control={control}
                        rules={{
                          required: "Health API URL is required",
                          pattern: {
                            value: /^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/i,
                            message: "Please enter a valid URL",
                          },
                        }}
                        render={({ field }) => (
                          <div>
                            <input
                              {...field}
                              type="text"
                              placeholder="Enter Health API URL"
                              className="w-full p-3 border border-gray-300 rounded-lg focus:ring-[#003366] focus:border-[#003366]"
                            />
                            {errors.apiDetails?.HEALTH && (
                              <p className="mt-2 text-sm text-red-600">
                                {errors.apiDetails.HEALTH.message}
                              </p>
                            )}
                          </div>
                        )}
                      />
                    </div>
                  )}

                  {watch("selectedAPIs.AUTH") && (
                    <div className="space-y-4">
                      <div className="flex items-center justify-between">
                        <h3 className="text-lg font-medium text-[#003366]">
                          Auth API Details
                        </h3>
                        <button
                          type="button"
                          onClick={() => {
                            setValue("selectedAPIs.AUTH", false);
                            setValue("apiDetails.authApi", "");
                            setValue("apiDetails.authApiUsername", "");
                            setValue("apiDetails.authApiPassword", "");
                          }}
                          className="text-gray-500 hover:text-gray-700"
                        >
                          <X className="w-5 h-5" />
                        </button>
                      </div>
                      <div className="space-y-4">
                        <Controller
                          name="apiDetails.AUTH"
                          control={control}
                          rules={{
                            required: "Auth API URL is required",
                            pattern: {
                              value: /^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/i,
                              message: "Please enter a valid URL",
                            },
                          }}
                          render={({ field }) => (
                            <div>
                              <input
                                {...field}
                                type="text"
                                placeholder="Enter Auth API URL"
                                className="w-full p-3 border border-gray-300 rounded-lg focus:ring-[#003366] focus:border-[#003366]"
                              />
                              {errors.apiDetails?.authApi && (
                                <p className="mt-2 text-sm text-red-600">
                                  {errors.apiDetails.authApi.message}
                                </p>
                              )}
                            </div>
                          )}
                        />

                        <Controller
                          name="apiDetails.authApiUsername"
                          control={control}
                          rules={{
                            required: "Username is required",
                          }}
                          render={({ field }) => (
                            <div>
                              <input
                                {...field}
                                type="text"
                                placeholder="Enter Username"
                                className="w-full p-3 border border-gray-300 rounded-lg focus:ring-[#003366] focus:border-[#003366]"
                              />
                              {errors.apiDetails?.authApiUsername && (
                                <p className="mt-2 text-sm text-red-600">
                                  {errors.apiDetails.authApiUsername.message}
                                </p>
                              )}
                            </div>
                          )}
                        />

                        <Controller
                          name="apiDetails.authApiPassword"
                          control={control}
                          rules={{
                            required: "Password is required",
                          }}
                          render={({ field }) => (
                            <div>
                              <input
                                {...field}
                                type="password"
                                placeholder="Enter Password"
                                className="w-full p-3 border border-gray-300 rounded-lg focus:ring-[#003366] focus:border-[#003366]"
                              />
                              {errors.apiDetails?.authApiPassword && (
                                <p className="mt-2 text-sm text-red-600">
                                  {errors.apiDetails.authApiPassword.message}
                                </p>
                              )}
                            </div>
                          )}
                        />
                      </div>
                    </div>
                  )}

                  <div className="flex justify-between mt-8">
                    <button
                      type="button"
                      onClick={() => setStep(step - 1)}
                      className="px-4 py-2 border border-gray-300 text-gray-600 rounded-md hover:bg-gray-50 transition-colors"
                    >
                      Back
                    </button>

                    <div className="space-x-4">
                      <button
                        type="button"
                        onClick={ErrorHandling}
                        className={`px-4 py-2 rounded-md ${
                          isConnectivityTesting
                            ? "bg-gray-300 cursor-not-allowed"
                            : "bg-blue-100 text-blue-700 hover:bg-blue-200"
                        }`}
                        disabled={isConnectivityTesting}
                      >
                        {isConnectivityTesting
                          ? "Testing..."
                          : "Test Connectivity"}
                      </button>

                      <button
                        type="submit"
                        className={`px-4 py-2 rounded-md transition-colors inline-flex items-center justify-center gap-2 min-w-[140px] h-10 ${
                          isConnectivityTesting ||
                          !isConnectivitySuccess ||
                          inputsChangedSinceTest ||
                          isSubmitting
                            ? "bg-gray-300 text-gray-500 cursor-not-allowed"
                            : "bg-[#003366] text-white hover:bg-[#002244]"
                        }`}
                        disabled={
                          isConnectivityTesting ||
                          !isConnectivitySuccess ||
                          inputsChangedSinceTest ||
                          isSubmitting
                        }
                      >
                        {isSubmitting ? (
                          <>
                            <Loader className="w-4 h-4 animate-spin" />
                            <span className="inline-block">Creating...</span>
                          </>
                        ) : (
                          <span>Create Endpoint</span>
                        )}
                      </button>
                    </div>
                  </div>
                </div>
              )}
            </form>
          </div>
        </>
      ) : (
        <div className="flex items-center justify-center w-full min-h-[400px] bg-white">
          <div className="text-center">
            <div className="flex justify-center mb-4">
              {error ? (
                <AlertCircle className="h-16 w-16 text-red-500 " />
              ) : (
                <CheckCircle className="h-16 w-16 text-green-500" />
              )}
            </div>
            <h2 className="text-lg font-semibold text-gray-900">
              {error
                ? "You do not have permission to add a new endpoint"
                : "Account Added Successfully!"}
            </h2>
            <p className="text-gray-600">Redirecting to endpoints page...</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default AddEndpointForm;
